export default __webpack_public_path__ + "static/media/dog-lqMIN.jpg.c94ef3bd.txt";